<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addRecord, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    modal-import(model="concepts")
    modal-concepts(:form='form', :isAdd='isModalAdd' :isVisible="isModalVisible" @closeModal="closeModal")
    modal-change-status(:concept="selectedConcept" :form="selectedConcept" :isVisible="isModalChangeStatusVisible" @closeModal="closeModalChangeStatus" @submit="updateStatus" :is-add='isModalAdd')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.concepts') }}:
            span {{ $t('strings.description', {attribute: $t('strings.concepts')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")
                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="exportRecords")
                    vm-icon(icon="download-outline")
                    slot &nbsp;{{ $t('strings.export') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(v-model="selected"  max-height="350px" :data="concepts" )
            h4 {{ concepts }}
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="300px")
                div
                .d-flex.justify-content-between
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")
                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                        vm-date-picker.filter(type="daterange" :label="$t('concepts.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.date")
                        vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                          vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                        //- Add filters
                            Agrega los filtros que prefieras por ejemplo:
                            vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                              vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")

                            NOTA: (agregar clase .filter)
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('concepts.'+ item)")
                    template(slot-scope="{data}")
                      vm-order-by-item(v-for="(item,index) in formattedData" :key="index" :value="item.value" :text="item.text" :direction="item.direction")
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list" style="display: none;")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('concepts.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column == 'charge' || column == 'payment'")  {{data[indextr][column] | currency }}
                  slot(v-if="column == 'date'")  {{data[indextr][column] | moment("DD MMMM YYYY").toUpperCase() }}
                  slot(v-if="column == 'conceptable_name'")  {{data[indextr]['conceptable']['name']}}
                  slot(v-if="column == 'conceptable_type'")  {{data[indextr][column] === 'App\\Models\\AdministrativeConcept' ? $t('concepts.admin') : data[indextr][column] == 'App\\Models\\Project' ? $t('concepts.project_mayus') : $t('concepts.supplier_mayus')}}
                  slot(v-if="column && column != 'created_at' && column != 'conceptable_name' && column != 'date' && column != 'charge' && column != 'payment' && column != 'conceptable_type' && column != 'role' && column != 'total' && column != 'status' && column != 'unit_price'") {{data[indextr][column]}}
                  vm-status-indicator(v-if="column == 'status'" :pulse="true" :color="statusColor(data[indextr][column])") {{data[indextr][column] === 1 ? 'PAGADO' : 'FACTURADO'}}
                vm-td
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click v-if="isConceptValid(data[indextr]) == 1")
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                  vm-dropdown-menu(style="width: 12rem")
                    vm-dropdown-item.d-flex.justify-content-between(@click="setSelectedRecord(data[indextr], tr)")
                      vm-icon(icon="edit-2-outline")
                      slot &nbsp;{{ $t('strings.edit') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="showModalChangeStatus(data[indextr])")
                      vm-icon(icon="checkmark-circle-outline")
                      slot &nbsp;{{ $t('strings.change_status') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="deleteRecordConfirm(data[indextr])")
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
                    //- More actions
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import moment from 'moment'
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Concepts')
const ModalImport = () => import('@/components/modals/ModalImport.vue')
const ModalConcepts = () => import('@/components/modals/ModalConcepts.vue')
const ModalChangeStatus = () => import('@/components/modals/ModalChangeConceptStatus.vue')

export default {
  name: 'Concepts',
  components: {
    ModalImport,
    ModalConcepts,
    ModalChangeStatus
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    form: {
      date: moment().format('YYYY-MM-DD'),
      conceptable_type: '',
      conceptable_id: '',
      concept: '',
      payment: 0,
      charge: 0,
      status: 1
    },
    isModalVisible: false,
    isModalChangeStatusVisible: false,
    selectedConcept: null,
    columns: ['date', 'conceptable_type', 'conceptable_name', 'concept', 'payment', 'charge', 'status'],
    columnsOrderBy: ['date', 'concept', 'payment', 'charge', 'status'],
    attributeModal: 'concept',
    status: [
      {
        value: 1,
        text: 'PAGADO'
      },
      {
        value: 2,
        text: 'FACTURADO'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        concept: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        date: []
      },
      orderBy: ''
    }
  }),
  computed: {
    ...mapGetters(['concepts', 'catalog', 'pagination', 'filterParams'])
  },
  methods: {
    ...mapActions([
      'loadRecords',
      'deleteRecord',
      'exportRecords',
      'applyFilter',
      'clearFilter',
      'editRecord'
    ]),
    isConceptValid (concept) {
      return ((moment(concept.date).format('YYYY-MM') === moment().format('2022-12') || moment(concept.date).format('YYYY') > 2022)) ? 1 : 0
    },
    statusColor (status) {
      return status === 1 ? 'success' : 'warning'
    },
    setSelectedRecord (record) {
      this.form = { ...record, payment: parseFloat(record.payment).toFixed(2), charge: parseFloat(record.charge).toFixed(2) }
      this.isModalAdd = false
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    },
    showModalChangeStatus (concept) {
      this.isModalAdd = false
      this.selectedConcept = { ...concept }
      this.isModalChangeStatusVisible = true
    },
    closeModalChangeStatus () {
      this.isModalChangeStatusVisible = false
    },
    updateStatus (form) {
      this.editRecord({ ...this.selectedConcept, ...form })
    },
    handleChange (date) {
      this.filters.betweenDates.date = date
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
